import '.b1{position:relative;}.ssr-plugin'
import '.l{width:100%;}.ssr-plugin'
import '.h0{min-height:200px;}.ssr-plugin'
import '.d{display:flex;}.ssr-plugin'
import '.e{flex-direction:column;}.ssr-plugin'
import '.at{justify-content:center;}.ssr-plugin'
import '.bq{align-items:flex-start;}.ssr-plugin'
import '.cu{padding:2rem;}.ssr-plugin'
import '.d9{background:var(--palette-white);}.ssr-plugin'
import '.ag{overflow:hidden;}.ssr-plugin'
import '.b6{position:absolute;}.ssr-plugin'
import '.j2{top:50%;}.ssr-plugin'
import '.j3{right:1rem;}.ssr-plugin'
import '.j4{transform:translateY(-50%);}.ssr-plugin'
import '.j5{width:120px;}.ssr-plugin'
import '.j6{height:120px;}.ssr-plugin'
import '.j7{z-index:0;}.ssr-plugin'
import '.r{align-items:center;}.ssr-plugin'
import '.i5{z-index:1;}.ssr-plugin'
import '.s{gap:0.5rem;}.ssr-plugin'
import '.j8{max-width:calc(100% - 140px);}.ssr-plugin'
import { Style, styled } from 'inlines'
import { Title } from '@app/components/core/typography/Title'
import { Text } from '@app/components/core/typography/Text'
import { Image } from '@app/components/core/image/Image'

export interface StatisticProps {
  number: string
  subtitle: string
  illustration?: string
  style?: Style
}

export const Statistic = ({
  number,
  subtitle,
  illustration,
  style,
}: StatisticProps) => {
  return (
    <styled.div className="b1 l h0 d e at bq cu d9 ag"
      data-testid="statistic"
      style={{
        ...style,
      }}
    >
      {/* Background Illustration - Right Aligned */}
      {illustration && (
        <div className="b6 j2 j3 j4 j5 j6 j7 d r at"
        >
          <Image
            src={illustration}
            alt={`${subtitle} illustration`}
            style={{
              width: '100%',
              height: '100%',
              objectFit: 'contain',
            }}
          />
        </div>
      )}

      {/* Content - Left Aligned with higher z-index */}
      <div className="b1 i5 d e bq s j8"
      >
        {/* Bold Number */}
        <Title.H1
          style={{
            fontSize: '4rem',
            fontWeight: '700',
            lineHeight: '100%',
            margin: 0,
            color: 'var(--brand-secondary)',
            fontFamily: 'FunnelDisplay',
          }}
        >
          {number}
        </Title.H1>

        {/* Subtitle */}
        <Text.Medium
          style={{
            color: 'var(--brand-secondary)',
            opacity: 0.8,
            margin: 0,
            lineHeight: '140%',
            fontWeight: '400',
          }}
        >
          {subtitle}
        </Text.Medium>
      </div>
    </styled.div>
  )
}
